import type { TCardProps } from '../Card'

export type TYoutubeCardProps = {
  youtubeId: string
} & TCardProps
